import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";

import StrategyDetails from './pages/StrategyDetails';
import Strategies from "./pages/Strategies";
import LandingPage from './pages/LandingPage';
import Navbar from "../src/components/Navbar"
import Footer from '../src/components/Footer'
import Voting from './pages/Vote'
import Notes from './pages/Note'
import NoteDetails from './pages/NoteDetails'
import Register from './pages/Register';
import Login from './pages/Login'
import MyProfile from './pages/MyProfile';
import MatchStats from './pages/MatchStats';
import MatchStatsDetails from './pages/MatchStatsDetails';

// AdminPanel
import Admin from '../src/pages/admin_pages/Admin';
import AdminMatches from './pages/admin_pages/Admin_matches';
import AdminLeagues from './pages/admin_pages/Admin_leagues';
import AdminTeams from './pages/admin_pages/Admin_teams';
import AdminUsers from './pages/admin_pages/Admin_users';
import AdminDashboard from './pages/admin_pages/Admin_dashboard';
import AdminMatchStats from './pages/admin_pages/Admin_match_stats';


// ToastBox import
import ToastBox from "../src/components/ToastBox";
import AszfPage from './pages/AszfPage';
import Contact from './pages/Contact';
import DataManagePage from './pages/DataManagePage';
import GyikPage from './pages/GyikPage';
import SportBetStatPage from './pages/SportBetStatPage';
import CalculatorOdds from './pages/calculators/CalculatorOdds';
import CalculatorBankroll from './pages/calculators/CalculatorBankroll';
import AdminMatchStatDefinitions from './pages/admin_pages/Admin_matchstat_definitions';
import CookieConsent from './components/CookieConsent';
import AdminEmails from './pages/admin_pages/Admin_emails';
import ForumPage from './pages/ForumPage';

function App() {
  const [toasts, setToasts] = useState([]);

  const addToast = (text, type = "success") => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, text, type }]);

    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 3000);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }

  return (
    <div className='app_wrapper'>

      <CookieConsent />

      <Router>
        <div className='app-wrapper'>
          <Navbar />
          <main className='main-content'>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/kezdolap" element={<LandingPage />} />
              <Route path="/strategiak" element={<Strategies addToast={addToast} />} />
              <Route path="/strategiak/:id" element={<StrategyDetails addToast={addToast} />} />

              <Route path="/szavazas" element={<Voting addToast={addToast} />} />
              <Route path="/jegyzetek" element={<Notes addToast={addToast} />} />
              <Route path="/jegyzetek/:id" element={<NoteDetails addToast={addToast} />} />

              <Route path="/bejelentkezes" element={<Login addToast={addToast} />}></Route>
              <Route path="/regisztracio" element={<Register addToast={addToast} />}></Route>
              <Route path='/profilom/:username' element={<MyProfile addToast={addToast} />}></Route>

              <Route path='/forum' element={<ForumPage addToast={addToast} />}></Route>

              <Route path='/meccselemzo' element={<MatchStats addToast={addToast} />}></Route>
              <Route path='/meccselemzo/:slug' element={<MatchStatsDetails addToast={addToast} />}></Route>


              {/* KALKULÁTOROK */}
              {/* <Route path='/kalkulator-odds' element={<CalculatorOdds></CalculatorOdds>} />
              <Route path='/kalkulator-bankroll' element={<CalculatorBankroll></CalculatorBankroll>} /> */}


              {/* STB */}
              <Route path='/aszf' element={<AszfPage />}></Route>
              <Route path='/kapcsolat' element={<Contact />}></Route>
              <Route path='/adatkezeles' element={<DataManagePage />}></Route>
              {/* <Route path='/gyik' element={<GyikPage />}></Route> */}
              <Route path='/sportfogadas-statisztika' element={<SportBetStatPage />}></Route>


              {/* AdminPanel */}
              <Route path='/adminmenu' element={<Admin addToast={addToast} />}></Route>
              <Route path='/admin/kezdolap' element={<AdminDashboard addToast={addToast} />}></Route>
              <Route path='/admin/meccsek' element={<AdminMatches addToast={addToast} />}></Route>
              <Route path='/admin/ligak' element={<AdminLeagues addToast={addToast} />}></Route>
              <Route path='/admin/csapatok' element={<AdminTeams addToast={addToast} />}></Route>
              <Route path='/admin/felhasznalok' element={<AdminUsers addToast={addToast} />}></Route>
              <Route path='/admin/statisztikak' element={<AdminMatchStats addToast={addToast} />}></Route>
              <Route path='/admin/statisztika-tipusok' element={<AdminMatchStatDefinitions addToast={addToast} />}></Route>
              <Route path='/admin/emailek' element={<AdminEmails addToast={addToast} />}></Route>

            </Routes>
          </main>
          <Footer />

          {/* ToastBox üzenetek */}
          <ToastBox toasts={toasts} onClose={removeToast} />
        </div>
      </Router>
    </div>
  );
}

export default App;
